import * as types from './types';

const resetFilter = () => ({
  type: types.RESET_FILTERS
});

const partialResetFilters = (filterName, filterValue) => ({
  type: types.PARTIAL_RESET_FILTERS,
  payload: {
    filterName,
    filterValue
  }
});

const toggleFiltersModal = () => ({ type: types.TOGGLE_FILTERS_MODAL });

const updateAppliedFilters = filters => ({
  type: types.UPDATE_APPLIED_FILTERS,
  payload: {
    filters
  }
});

export { toggleFiltersModal, resetFilter, updateAppliedFilters, partialResetFilters };
